module.exports = __webpack_public_path__ + "static/media/yellow_waves@2x.80758f6d.png";